"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _containers = require("./containers");

var _auth = require("./redux/modules/auth");

var _company = require("./redux/modules/company");

var _transportDocuments = require("./redux/modules/transportDocuments");

var _userVouchers = require("./redux/modules/userVouchers");

var _userPickupVouchers = require("./redux/modules/userPickupVouchers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/display-name */
exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (!user) {
        replace("/kirjaudu");
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth).catch(checkAuth);
    } else {
      checkAuth();
    }
  };

  var requireVouchers = function requireVouchers(nextState, replace, cb) {
    function checkVouchers() {
      var _store$getState2 = store.getState(),
          vouchers = _store$getState2.userVouchers.vouchers;

      if (!vouchers || !vouchers.length) {
        replace("/");
      }
      cb();
    }

    if (!(0, _userVouchers.isReceptionVouchersLoaded)(store.getState())) {
      var token = nextState.params.token;
      store.dispatch((0, _userVouchers.loadReceptionVouchersByToken)(token)).then(checkVouchers).catch(checkVouchers);
    } else {
      checkVouchers();
    }
  };

  var requirePickupVouchers = function requirePickupVouchers(nextState, replace, cb) {
    function checkVouchers() {
      var _store$getState3 = store.getState(),
          vouchers = _store$getState3.userPickupVouchers.vouchers;

      if (!vouchers || !vouchers.length) {
        replace("/");
      }
      cb();
    }

    if (!(0, _userPickupVouchers.isPickupVouchersLoaded)(store.getState())) {
      var token = nextState.params.token;
      store.dispatch((0, _userPickupVouchers.loadPickupVouchersByToken)(token)).then(checkVouchers).catch(checkVouchers);
    } else {
      checkVouchers();
    }
  };

  var requireTransportDocument = function requireTransportDocument(nextState, replace, cb) {
    function checkTransportDocuments() {
      var _store$getState4 = store.getState(),
          transportDocuments = _store$getState4.transportDocuments.transportDocuments;

      if (!transportDocuments || !transportDocuments.length) {
        replace("/");
      }
      cb();
    }

    if (!(0, _transportDocuments.isTransportDocumentsLoaded)(store.getState())) {
      var token = nextState.params.token;
      store.dispatch((0, _transportDocuments.loadAnonTransportDocument)(token)).then(checkTransportDocuments).catch(checkTransportDocuments);
    } else {
      checkTransportDocuments();
    }
  };

  var requireCompanyAdmin = function requireCompanyAdmin(nextState, replace, cb) {
    function checkCompany() {
      var _store$getState5 = store.getState(),
          company = _store$getState5.company.company;

      if (!company || !company.users.length) {
        replace("/");
      }
      cb();
    }

    if (!(0, _company.isLoaded)(store.getState())) {
      store.dispatch((0, _company.load)()).then(checkCompany).catch(checkCompany);
    } else {
      checkCompany();
    }
  };

  var requireCompany = function requireCompany(nextState, replace, cb) {
    function checkCompany() {
      var _store$getState6 = store.getState(),
          company = _store$getState6.company.company;

      if (!company) {
        replace("/");
      }
      cb();
    }

    if (!(0, _company.isLoaded)(store.getState())) {
      store.dispatch((0, _company.load)()).then(checkCompany).catch(checkCompany);
    } else {
      checkCompany();
    }
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: "/", component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireTransportDocument },
      _react2.default.createElement(_reactRouter.Route, {
        path: "/tulosta/ajot/:token",
        component: _containers.PrintableTransportDocument
      })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireVouchers },
      _react2.default.createElement(_reactRouter.Route, { path: "/vastaanottolipukkeet/:token", component: _containers.UserVouchers }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/vastaanottolipukkeet/:token/:voucherId",
        component: _containers.UserVouchers
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/tulosta/vastaanottolipukkeet/:token/:voucherId",
        component: _containers.PrintableVoucher
      })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requirePickupVouchers },
      _react2.default.createElement(_reactRouter.Route, { path: "/noutolipukkeet/:token", component: _containers.UserPickupVouchers }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/noutolipukkeet/:token/:voucherId",
        component: _containers.UserPickupVouchers
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/tulosta/noutolipukkeet/:token/:voucherId",
        component: _containers.PrintablePickupVoucher
      })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireLogin },
      _react2.default.createElement(_reactRouter.Route, { path: "/ilmoitukset/:adId/muokkaa", component: _containers.EditAd }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/ilmoitukset/:adId/projekti/:projectId/muokkaa",
        component: _containers.EditAd
      }),
      _react2.default.createElement(_reactRouter.Route, { path: "/omat-tietoni", component: _containers.MyProfile }),
      _react2.default.createElement(_reactRouter.Route, { path: "/omat-ajot", component: _containers.TransportDocuments }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireCompany },
        _react2.default.createElement(_reactRouter.Route, { path: "/projektit", component: _containers.Projects }),
        _react2.default.createElement(_reactRouter.Route, { path: "/lisenssit", component: _containers.LicenseManager }),
        _react2.default.createElement(_reactRouter.Route, { path: "/projekti/:id", component: _containers.Project }),
        _react2.default.createElement(_reactRouter.Route, { path: "/uusi-projekti", component: _containers.CreateProject }),
        _react2.default.createElement(_reactRouter.Route, {
          path: "/projekti/:id/kayttajat",
          component: _containers.ProjectUserManagement
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: "/jata-ilmoitus/projekti/:projectId",
          component: _containers.CreateAd
        }),
        _react2.default.createElement(_reactRouter.Route, { path: "/projekti/:id/muokkaa", component: _containers.EditProject })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: "/ostetut-vastaanottolipukkeet", component: _containers.UserVouchers }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/ostetut-vastaanottolipukkeet/:orderId/:voucherId",
        component: _containers.UserVouchers
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/tulosta/ostetut-vastaanottolipukkeet/:orderId/:voucherId",
        component: _containers.PrintableVoucher
      }),
      _react2.default.createElement(_reactRouter.Route, { path: "/ostetut-noutolipukkeet", component: _containers.UserPickupVouchers }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/ostetut-noutolipukkeet/:orderId/:voucherId",
        component: _containers.UserPickupVouchers
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: "/tulosta/ostetut-noutolipukkeet/:orderId/:voucherId",
        component: _containers.PrintablePickupVoucher
      }),
      _react2.default.createElement(_reactRouter.Route, { path: "/maksullinen-profiili", component: _containers.License }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireCompanyAdmin },
        _react2.default.createElement(_reactRouter.Route, { path: "/oma-yritys", component: _containers.Company })
      )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: "/maksullinen-profiili/:id/success", component: _containers.License }),
    _react2.default.createElement(_reactRouter.Route, { path: "/maksullinen-profiili/:id/failure", component: _containers.License }),
    _react2.default.createElement(_reactRouter.Route, { path: "/autologin", component: _containers.AutoLogin }),
    _react2.default.createElement(_reactRouter.Route, { path: "/hinnasto", component: _containers.PriceList }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ilmoittaminen-palvelussa", component: _containers.AdNotice }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ilmoitukset", component: _containers.Ads }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ilmoitukset/vastaanotettavat", component: _containers.Ads }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ilmoitukset/tarjottavat", component: _containers.Ads }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ilmoitukset/:adId", component: _containers.Ads }),
    _react2.default.createElement(_reactRouter.Route, { path: "/jata-ilmoitus", component: _containers.CreateAd }),
    _react2.default.createElement(_reactRouter.Route, { path: "/kayttoehdot", component: _containers.TermsOfService }),
    _react2.default.createElement(_reactRouter.Route, { path: "/kirjaudu", component: _containers.Login }),
    _react2.default.createElement(_reactRouter.Route, { path: "/kirjaudu/uusi-salasana", component: _containers.Login }),
    _react2.default.createElement(_reactRouter.Route, { path: "/lipukekauppa", component: _containers.VoucherStore }),
    _react2.default.createElement(_reactRouter.Route, { path: "/lipukekauppa/:id/success", component: _containers.VoucherStore }),
    _react2.default.createElement(_reactRouter.Route, { path: "/lipukekauppa/:id/failure", component: _containers.VoucherStore }),
    _react2.default.createElement(_reactRouter.Route, { path: "/lipukekauppa-nouto", component: _containers.PickupVoucherStore }),
    _react2.default.createElement(_reactRouter.Route, {
      path: "/lipukekauppa-nouto/:id/success",
      component: _containers.PickupVoucherStore
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: "/lipukekauppa-nouto/:id/failure",
      component: _containers.PickupVoucherStore
    }),
    _react2.default.createElement(_reactRouter.Route, { path: "/rekisteroidy", component: _containers.Registration }),
    _react2.default.createElement(_reactRouter.Route, { path: "/r/:invitationToken", component: _containers.LicenseRegistration }),
    _react2.default.createElement(_reactRouter.Route, { path: "/suosittele", component: _containers.Recommend }),
    _react2.default.createElement(_reactRouter.Route, { path: "/maalajikuvaukset", component: _containers.DirtClasses }),
    _react2.default.createElement(_reactRouter.Route, { path: "/tietoa-palvelusta", component: _containers.ServiceInfo }),
    _react2.default.createElement(_reactRouter.Route, { path: "/uusi-salasana", component: _containers.ResetPassword }),
    _react2.default.createElement(_reactRouter.Route, {
      path: "/vaihda-salasana/:passwordToken",
      component: _containers.ChangePassword
    }),
    _react2.default.createElement(_reactRouter.Route, { path: "/vahvista-sahkoposti/:verifyToken", component: _containers.VerifyEmail }),
    _react2.default.createElement(_reactRouter.Route, { path: "/yhteystiedot", component: _containers.ContactInfo }),
    _react2.default.createElement(_reactRouter.Route, { path: "/palaute", component: _containers.Feedback }),
    _react2.default.createElement(_reactRouter.Route, { path: "/lisapalvelut", component: _containers.Services }),
    _react2.default.createElement(_reactRouter.Route, { path: "*", component: _containers.NotFound, status: 404 })
  );
};
// import { EditProject } from './containers/Projects/EditProject';

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1258
 ** module chunks = 0
 **/